import React, { Component } from 'react';
import MyGoalContainer from "./okr/common_okr_components/myGoalContainer.component";
import {okrDetailConstants} from "../constants/okr/okrDetails.constants";

class PersonKrApp extends Component {

    render() {
        let params = {status: 1,f: 2}
        return (
                <MyGoalContainer
                    type = {okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH}
                    showFilter = {true}
                    showManagerFilter = {true}
                    showHideShowOkr = {true}
                    onlyShowOverDueFilter = {true}
                    url = 'getPersonKrLists'
                    params = {params}
                    isSortingEnable = {false}
                    progressType = 'BAR'
                    showGoalName = {false}
                    showTeamName = {true}
                    showUserName = {false}
                    pagination = {true}
                    paginationLimit = {15}
                    offset = {0}
                    showSourceName = {false}
                />
         );
    }
}

export default PersonKrApp;
